// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__qFk12","content":"styles_content__1GeK5","row":"styles_row__Fwwor","footer":"styles_footer__1jXJM","phraseLength":"styles_phraseLength__p5RVd"};